import { render, staticRenderFns } from "./iconDeleteSuggestion.vue?vue&type=template&id=65c3814e&scoped=true"
import script from "./iconDeleteSuggestion.vue?vue&type=script&lang=js"
export * from "./iconDeleteSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c3814e",
  null
  
)

export default component.exports